import { grey } from '@material-ui/core/colors';

export default {
  chip: {
    background: 'white',
    '&:hover': { background: 'white' },
  },
  smallIcon: { fontSize: 16 },
  nameInput: { fontSize: 12 },
  avatar: { background: grey[300] },
};
